import { render, staticRenderFns } from "./vipPkg.vue?vue&type=template&id=53a4e177&scoped=true"
import script from "./vipPkg.vue?vue&type=script&lang=js"
export * from "./vipPkg.vue?vue&type=script&lang=js"
import style0 from "./vipPkg.vue?vue&type=style&index=0&id=53a4e177&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53a4e177",
  null
  
)

export default component.exports